// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.51ed9047e',
  revision: '51ed9047e',
  branch: 'develop',
  date: 'Tue, 15 Sep 2026 10:35:18 GMT'
};